// extracted by mini-css-extract-plugin
module.exports = {"root":"mumXwB","ratings":"u0OjB_","stars":"eHssKv"};